export const getParamsByKey = (router, key) => {
    return router.query[key]?.split(',')
}
